import React from "react";

import { Icon } from "rhombus-react";

import "./Sparkler.css";

const MAX_DURATION = 3;

export default function Sparkler(){
	return (
		<div className="sparkler">
			<Icon name="far fa-wand-magic" />
			<Icon
				name="fas fa-flip fa-star"
				className="sparkle"
				style={{
					"--fa-animation-duration": `${Math.random() * MAX_DURATION + 1}s`,
					top: "5%",
					left: "35%",
					fontSize: "6px",
				}}
			/>
			<Icon
				name="fas fa-flip fa-star"
				className="sparkle"
				style={{
					"--fa-animation-duration": `${Math.random() * MAX_DURATION + 1}s`,
					top: "10%",
					left: "0%",
					fontSize: "12px",
				}}
			/>
			<Icon
				name="fas fa-flip fa-star"
				className="sparkle"
				style={{
					"--fa-animation-duration": `${Math.random() * MAX_DURATION + 1}s`,
					top: "55%",
					left: "60%",
					fontSize: "8px",
				}}
			/>
		</div>
	);
}

Sparkler.displayName = "Sparkler";
